import Typography from "@mui/material/Typography"
import { makeStyles } from "tss-react/mui-compat"
import Markdown from "components/Markdown"
import useHeadingStyles from "hooks/useHeadingStyles"
import useLaunchpadContext from "hooks/useLaunchpadContext"

const useStyles = makeStyles()(
  (_theme) => ({
    root: {
      maxWidth: "842px",
    },
    text: {
      marginTop: "20px",
      color: "#000000",
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "22px",
    },
  }),
)

interface ILaunchpadDetails {}

const LaunchpadDetails = (_props: ILaunchpadDetails) => {
  const { convention } = useLaunchpadContext()

  const { classes } = useStyles()

  const { classes: headingClasses } = useHeadingStyles()

  if (!convention.details) {
    return null
  }

  return (
    <div className={classes.root}>
      <Typography variant="h2" className={headingClasses.microh3}>
        Details
      </Typography>
      <div className={classes.text}>
        <Markdown>{convention.details}</Markdown>
      </div>
    </div>
  )
}

export default LaunchpadDetails
